<script lang="ts">
import { storeToRefs } from "pinia"
import { useOnlineStore, useUserStore } from "../../store"

export default {
    name: "OfflineChip",
    props: ["variant"],
    setup() {
        const onlineStore = useOnlineStore()
        const { online, offlineReady, onlineLoading, onlineReady, loaded } = storeToRefs(onlineStore)
        const { currentUser } = storeToRefs(useUserStore())
        return {
            online,
            offlineReady,
            onlineLoading,
            onlineReady,
            loaded,
            currentUser,
        }
    },
}
</script>

<template>
    <div v-if="!currentUser || currentUser.role !== 'admin'" />
    <v-chip v-else-if="!online" color="info">
        <v-icon icon="mdi-cloud-off-outline" size="x-large" />
        <span v-if="variant !== 'small'" class="ml-4"> Mode hors ligne</span>
    </v-chip>
    <v-chip v-else-if="online && !onlineReady" color="warning">
        <v-progress-circular indeterminate size="16" />
        <span v-if="variant !== 'small'" class="ml-4"> Synchronisation vers le serveur</span>
    </v-chip>
    <v-chip v-else-if="online && offlineReady && !onlineLoading" color="green">
        <v-icon icon="mdi-cloud-outline" size="x-large" />
        <span v-if="variant !== 'small'" class="ml-4">Pret à passer hors ligne</span>
    </v-chip>
    <v-chip v-else-if="online && onlineLoading" color="warning">
        <v-progress-circular v-if="!loaded" indeterminate size="16" />
        <v-progress-circular v-else :model-value="loaded" size="16" />
        <span v-if="variant !== 'small'" class="ml-4"> Téléchargement des informations</span>
    </v-chip>
</template>
